import OrderTransportingOrderAvailableDriversRequest, {
  OrderTransportingOrderAvailableDriversQueryParams,
} from "./order-transporting-order-available-drivers.request";

const createQueryParams = (
  request: OrderTransportingOrderAvailableDriversRequest,
): OrderTransportingOrderAvailableDriversQueryParams => {
  return {
    fulltextSearchCriteria: request.fulltextSearchCriteria,
    limit: request.limit,
  };
};

const orderTransportingOrderAvailableDriversRequestFactory = {
  createQueryParams,
};

export default orderTransportingOrderAvailableDriversRequestFactory;
